export const BASE_NATIONAL_MEDALS = 525;
export const BASE_INTERNATIONAL_MEDALS = 57;
export const BASE_DOCUMENTED_MEDALS =
  BASE_NATIONAL_MEDALS + BASE_INTERNATIONAL_MEDALS;

const toCount = (value) => Number(value || 0);

export const getAddedNationalMedals = (medalSummary) =>
  toCount(medalSummary?.by_level?.National);

export const getAddedInternationalMedals = (medalSummary) =>
  toCount(medalSummary?.by_level?.International);

export const getLiveNationalMedals = (medalSummary) =>
  BASE_NATIONAL_MEDALS + getAddedNationalMedals(medalSummary);

export const getLiveInternationalMedals = (medalSummary) =>
  BASE_INTERNATIONAL_MEDALS + getAddedInternationalMedals(medalSummary);

export const getLiveDocumentedMedalTotal = (medalSummary) =>
  getLiveNationalMedals(medalSummary) +
  getLiveInternationalMedals(medalSummary);
